<template>
  <div class="tw-inline-block tw-shrink-0 tw-cursor-help">
    <!-- icon start -->
    <fluent-icon
      v-if="props.type === 'tip'"
      icon="info"
      :size="props.size"
    ></fluent-icon>
    <fluent-icon
      v-if="props.type === 'why'"
      icon="question_circle"
      :size="props.size"
    ></fluent-icon>
    <fluent-icon
      v-if="props.type === 'important'"
      icon="warning"
      :size="props.size"
    ></fluent-icon>
    <!-- icon end -->

    <q-tooltip
      :offset="[0, 12]"
      anchor="bottom right"
      self="top right"
      :delay="300"
    >
      <div class="tw-text-xs">
        <slot></slot>
      </div>
    </q-tooltip>
  </div>
</template>

<script setup lang="ts">
export interface Props {
  /**
   * In short, use "why" when you want to explain why something is the way it is or why something is needed.
   * Use "tip" when you want to give a tip or a suggestion.
   * Use "important" when you want to relay important information.
   * @see https://bootcamp.uxdesign.cc/when-to-use-and-i-in-your-ux-a2d63038a274
   */
  type?: 'tip' | 'why' | 'important';
  size?: string;
}
// with defaults
const props = withDefaults(defineProps<Props>(), {
  type: 'tip',
  size: '16',
});
</script>

<style lang="scss" scoped></style>
